import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "xl:h-8 md:h-[25px] min-h-[17px] text-left content-center rounded-[4px] md:rounded-lg bg-[#D39F47FF] text-white sf-pro font-semibold text-[11px] leading-100p md:text-sm md:leading-[21px] xl:text-base xl:leading-[28px] px-1 md:px-2 py-0.5" }




export default /*@__PURE__*/_defineComponent({
  __name: 'BlogCardTag',
  props: {
    tagName: {},
    bgImage: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(props.tagName), 1))
}
}

})